<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Beneficio Complementario
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="nuevo" v-html="'Nuevo'" />
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12">
                        <ModalBeneficioComplementario :objFormBeneComp="objFormBeneComp" :listGeneral="listGeneral" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Aseguradora *" color="textbox" v-model="objSearchBeneComp.idAseguradora"
                            @change="onListarSeguros($event,true)" :items="listGeneral.listAseguradora"
                            item-value="idAseguradora" item-text="aseguradora" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Seguro" color="textbox" v-model="objSearchBeneComp.idSeguro"
                            @change="onListarBeneficiosComplementarios" :items="listGeneral.listSeguro"
                            item-value="idSeguro" item-text="seguro" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado *" color="textbox" v-model="objSearchBeneComp.idEstado"
                            :items="listGeneral.listEstados" item-text="nombre_estado" item-value="id_estado"
                            @change="onListarBeneficiosComplementarios" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objSearchBeneComp.search" clearable
                            prepend-inner-icon="search" dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="objSearchBeneComp.search" :headers="listGeneral.cabecera"
                            :items="listGeneral.detalle" class="elevation-3">

                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="editar(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>

                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-text="objSearchBeneComp.search"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: 'BeneficioComplementarioView',
        components:{
            ModalBeneficioComplementario: () => import('@/components/beneficio/ModalBeneficioComplementarioComponent')
        },
        data: () => ({
            objSearchBeneComp: {
                idAseguradora: null,
                idSeguro: null,
                idEstado: null,
                search:''
            },
            objFormBeneComp: {
                titulo: 'Nuevo Beneficio Complementario',
                abrirModal: false,
                id_estado: null
            },
            listGeneral: {},
            listParametros: {}
        }),
        created() {
            axios.post(`${BASE_URI}administrador/beneficioComplementario/cargaGeneral`, {})
                .then((r) => {
                    if (_.get(r, ['data', 'existeError'], true)) throw mensajeEstandar.errorPeticion;
                    if (_.size(_.get(r, ['data', 'data'], [])) == 0) throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion);
                        this.listGeneral = r.data.data.listas;
                        this.listParametros = r.data.data.parametros;
                        this.objSearchBeneComp.idEstado = this.listParametros.idEstadoDefault;
                        this.objFormBeneComp.id_estado = _.toString(this.listParametros.idEstadoDefault);
                        this.objSearchBeneComp.idAseguradora = this.listGeneral.listAseguradora[0].idAseguradora;
                        this.objSearchBeneComp.idEstado = this.listGeneral.listEstados[0].id_estado;
                        return this.onListarSeguros('L');
                })
                .then((respuesta) => {
                    return this.onListarBeneficiosComplementarios('L');
                })
                .catch((e) => {
                    mensajesAlerta(e, 'E');
                })
        },
        methods: {
            ApiSend(ruta, objeto) {
                return axios.post(`${BASE_URI}${ruta}`, objeto);
            },
            onListarSeguros(event, activar = false) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        opcion: 'L_SEGURO_X_ASEGURADORA',
                        idAseguradora: _.get(this.objSearchBeneComp, 'idAseguradora', null),
                        idTipoPoliza: this.listParametros.id_tipo_poliza_maestra,
                        idEstado: _.get(this.objSearchBeneComp, 'idEstado', null) == 0 ? null : _.get(this.objSearchBeneComp, 'idEstado', null),
                    };

                    this.objSearchBeneComp.idSeguro = null;
                    this.$set(this.listGeneral, 'detalle', []);

                    var p = this.ApiSend('administrador/poliza/listar', objeto)
                        .then((r) => {
                            if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                            if (_.get(r, ['data', 'existeError'], true)) throw _.get(r, ['data', 'mensaje'],mensajeEstandar.errorPeticion);
                            if (_.size(r.data.data) > 0) {
                                this.$set(this.listGeneral, 'listSeguro', r.data.data);
                                this.$set(this.objSearchBeneComp, 'idSeguro', this.listGeneral.listSeguro[0].idSeguro);
                            } else
                                mensajesAlerta(r.data.mensaje, 'I');
                            return r;
                        });

                    if (activar) {
                        p.then((r) => {
                                return this.onListarBeneficiosComplementarios('L');
                            })
                            .catch((e) => {
                                mensajesAlerta(e, 'E');
                            });
                    }

                    return p;
                }
            },
            onListarBeneficiosComplementarios(event) {
                if (!_.isUndefined(event)) {
                    var objeto = {
                        opcion        : 'L_COMBO',
                        id_aseguradora: _.get(this.objSearchBeneComp, 'idAseguradora', null),
                        id_seguro     : _.get(this.objSearchBeneComp, 'idSeguro', null) == 0 ? null : _.get(this.objSearchBeneComp, 'idSeguro', null),
                        id_estado     : _.get(this.objSearchBeneComp, 'idEstado', null) == 0 ? null : _.get(this.objSearchBeneComp, 'idEstado', null),
                    };

                    this.$set(this.listGeneral, 'detalle', []);
                    var p = this.ApiSend('administrador/beneficioComplementario/listar', objeto)
                        .then((r) => {
                            if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                            if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if (_.size(_.get(r,['data','data'],[])) > 0) {
                                var l =  _.map(r.data.data, (v) => { 
                                                                        v.beneficio_comp = v.beneficio;
                                                                        v.estado = (_.find(this.listGeneral.listEstados, (o) => { return parseInt(o.id_estado) == parseInt(v.idEstado) })).nombre_estado;
                                                                        return v;
                                                                    });
                                this.$set(this.listGeneral, 'detalle',l);
                            } else
                                mensajesAlerta(r.data.mensaje, 'I');
                            return r;
                        });
                    if (event instanceof Event)
                        p.catch((e) => {
                            mensajesAlerta(e, 'E');
                        });

                    return p;
                }
            },
            nuevo() {
                this.objFormBeneComp.abrirModal = true;
                this.$children[0].$children[6].cargaGeneral(true);
            },
            editar(objeto) {
                this.objFormBeneComp = _.merge({}, this.objFormBeneComp, objeto, {
                    titulo: 'Editar Beneficio Complementario',
                    'abrirModal': true
                });
                this.$children[0].$children[6].cargaGeneral(true);
            },
            insertarActualizar() {
                return this.ApiSend('administrador/beneficioComplementario/insertOrUpdate', this.objFormBeneComp)
                    .then((r) => {
                        if (r.status != 200 || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                        if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r,['data','data'],[])) > 0) {
                            this.$children[0].$children[6].cargaGeneral(false);
                            this.objFormBeneComp = {
                                                        titulo: 'Nuevo Beneficio Complementario',
                                                        abrirModal: false,
                                                        id_estado: this.listParametros.idEstadoDefault
                                                    };

                            mensajeAlertaTiempo(r.data.mensaje, 'S');
                            return this.onListarBeneficiosComplementarios('L');
                        }
                    })
                    .catch((e) => {
                        mensajesAlerta(e, 'E');
                        return e;
                    })
            }
        }
    }
</script>

<style>

</style>